export default function (value) {
  if (window.__PRERENDER_INJECTED) {
    return `${process.env.NODE_FRONT_HOST}${value}`;
  }
  return `${window.location.protocol}//${window.location.host}/${value}`;
}



// WEBPACK FOOTER //
// ./src/assets/plugin/filters/hrefFormat.js